import React, { FunctionComponent } from "react";
import SpeakersList from "../../components/speakers/speakersList";
import { SpeakersListProps } from "../../interfaces/interfaces";

const Speakers: FunctionComponent<SpeakersListProps> = ({ speakers, isSpeakerBioEnabled }) => {
  // Determine if there is a speaker pending approval
  const speakerIsPendingApproval = speakers ? speakers.filter(
    (speaker) => speaker.isPendingApproval
  ) : [];
  return (
    <div id="speakers">
      <h2>Speakers</h2>
      <SpeakersList speakers={speakers} isSpeakerBioEnabled={isSpeakerBioEnabled} />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      {speakerIsPendingApproval.length > 0 && <div className="pending">* Pending Agency Approval</div>}
    </div>
  );
};

export default Speakers;
